/**
 * Rewrites the header donate button's URL on page load so that inbound
 * GoFundMe Pro/UTM tracking params are preserved through to the donate page.
 * See DR-1815.
 */
import { buildDonateUrl } from './build-donate-url';

function init() {
  const button = document.getElementById('header-button-donate');

  if (!button) {
    return;
  }

  // The button's href is our own `/donate` endpoint, so UTM params must be
  // aliased to survive Pantheon's edge cache. See build-donate-url.js.
  button.setAttribute('href', buildDonateUrl(button.getAttribute('href'), {}, { aliasUtmParams: true }));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
